import template from './admin.html';
import templateAdminHotelList from './admin-hotel-list/admin-hotel-list.html';
import templateAdminError404 from './admin-error404.html';
export const GRANTED_ROLES = ['HotelAdmin', 'Admin'];

export const adminStates = {
    HOTEL_LIST: 'admin.hotel-list',
    HOTEL_LIST_RESULTS: 'admin.hotel-list.results',
    HOTEL_VIEW: 'admin.hotel-view',
    HOTEL_EDIT: 'admin.hotel-edit',
    HOTEL_MERGE: 'admin.hotel-merge',
    ERROR_404: 'admin.error404',
    FAX: 'admin.fax',
    FAX_LIST_RESULTS: 'admin.fax.results',
    FAX_DETAILS: 'admin.fax-details',
    FAX_PDF: 'admin.fax-pdf',
};


export default function AppAdminRoutes($stateProvider) {
    'ngInject';

    $stateProvider
        .state('admin', {
            abstract: true,
            template,
            onEnter: function($state, $location, authService, userService) {
                'ngInject';
                if (userService.checkPermissions(GRANTED_ROLES)) {
                    return;
                }
                authService.logout();
            },
        })
        .state(adminStates.HOTEL_LIST, {
            url: '/admin/hotel-list',
            template: templateAdminHotelList,
        })
        .state(adminStates.HOTEL_LIST_RESULTS, {
            url: '/?name&suppliers&min&max&latitude&longitude&searchRadius',
            template: '<div kt-admin-hotel-search-results="$resolve.hotelProfiles"></div>',
            resolve: {
                hotelProfiles: function($stateParams, adminHotelListService) {
                    'ngInject';
                    return adminHotelListService.getHotels($stateParams);
                },
            },
            params: {
                name: {
                    value: null,
                    squash: true,
                },
                suppliers: {
                    value: [],
                    squash: true,
                },
                latitude: {
                    value: null,
                    squash: true,
                },
                longitude: {
                    value: null,
                    squash: true,
                },
                searchRadius: {
                    value: null,
                    squash: true,
                },
            },
        })
        .state(adminStates.HOTEL_VIEW, {
            url: '/admin/hotel-view/:hotelId',
            template: '<div kt-admin-hotel-view="$resolve.hotel"></div>',
            resolve: {
                hotel: function($stateParams, adminService, adminHotelViewService) {
                    'ngInject';
                    return adminHotelViewService.getHotelProfile($stateParams.hotelId)
                        .catch(adminService.handle404);
                },
            },
        })
        .state(adminStates.HOTEL_EDIT, {
            url: '/admin/hotel-edit/:hotelId',
            template: '<div kt-admin-hotel-edit="$resolve.hotel"></div>',
            resolve: {
                hotel: function($stateParams, adminService, adminHotelEditService) {
                    'ngInject';
                    return adminHotelEditService.getHotelProfile($stateParams.hotelId)
                        .catch(adminService.handle404);
                },
            },
        })
        .state(adminStates.HOTEL_MERGE, {
            url: '/admin/hotel-merge',
            template: '<div kt-admin-hotel-merge></div>',
        })
        .state(adminStates.FAX, {
            url: '/admin/fax',
            template: '<div kt-admin-fax></div>',
        })
        .state(adminStates.FAX_LIST_RESULTS, {
            url: '/results?min&max&referenceNo&hotelName&tripId&pnr&documentType&faxStatus&arrivalDate&sentDateFrom&sentDateTo',
            params: {
                min: {
                    value: '0',
                    squash: false,
                },
                max: {
                    value: '20',
                    squash: false,
                },
                hotelName: {
                    value: null,
                    squash: true,
                },
                referenceNo: {
                    value: null,
                    squash: true,
                },
                tripId: {
                    value: null,
                    squash: true,
                },
                pnr: {
                    value: null,
                    squash: true,
                },
                arrivalDate: {
                    value: null,
                    squash: false,
                },
                sentDateFrom: {
                    value: null,
                    squash: true,
                },
                sentDateTo: {
                    value: null,
                    squash: true,
                },
                documentType: {
                    value: [],
                    squash: true,
                },
                faxStatus: {
                    value: [],
                    squash: true,
                },
            },
            template: '<div kt-admin-fax-search-results="$resolve.faxResults"></div>',
            resolve: {
                faxResults: function($stateParams, adminFaxSearchService) {
                    'ngInject';
                    return adminFaxSearchService.getFaxes($stateParams);
                },
            },
        })
        .state(adminStates.FAX_DETAILS, {
            url: '/admin/fax-details/:faxId/:referenceNo/:faxNumber/:hash',
            template: '<div kt-admin-fax-details=""></div>',
        })
        .state(adminStates.FAX_PDF, {
            url: '/admin/fax-pdf/:faxId',
            template: '<div kt-admin-fax-pdf="$resolve.pdfBlob"></div>',
            resolve: {
                pdfBlob: function($stateParams, adminFaxPdfService) {
                    'ngInject';
                    return adminFaxPdfService.getFaxPdf($stateParams.faxId);
                },
            },
        })
        .state(adminStates.ERROR_404, {
            template: templateAdminError404,
        });
}



// WEBPACK FOOTER //
// ./src/app/modules/admin/admin-routes.js